import React from 'react'
import FooterBottom from './FooterBottom'
import SubFooter from './SubFooter'
const Footer = () => {
  return (
    <div className="footer-light ">
        <FooterBottom />
        <SubFooter />
    </div>
  )
}

export default Footer